const SC = [
  ['Buscar cliente', 'F2'],
  ['Agregar producto', 'Alt + P'],
  ['Cambiar tipo doc.', 'Alt + T'],
  ['Aplicar descuento', 'Alt + D'],
  ['Guardar borrador', 'Ctrl + S'],
  ['Emitir factura', 'F10'],
]

export default function Shortcuts() {
  return (
    <div className="shortcuts">
      <div className="shortcuts-title">Atajos</div>
      {SC.map(([l, k]) => (
        <div key={l} className="shortcut-row"><span>{l}</span><span className="kbd">{k}</span></div>
      ))}
    </div>
  )
}
